<template>
  <v-navigation-drawer
    app
    right
    :mini-variant="miniVariant"
    v-model="isMainMenuActive"
    v-if="!isMainMenuHidden"
    persistent
  >
    <v-list class="pa-1">
      <v-list-item>
        <v-list-item-avatar>
          <img :src="userAvatar">
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ user.name }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <div
      v-for="(menu, index) in menus"
      :key="`menu${index}`"
    >
      <v-divider></v-divider>
      <v-list nav>
        <template
          value="true"
          v-for="(item) in menu"
        >
          <!-- Regular link -->
          <v-list-item
            v-if="item.path"
            :key="item.title"
            :to="item.path"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Function -->
          <v-list-item
            v-else
            :key="item.title"
            @click="envokeMethodByName(item.click)"
          >
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>

<script>
import colors from "vuetify/es5/util/colors";
import shouldShow from "@/utils/shouldShow";
import { camelCase } from "lodash";

export default {
  data: () => ({
    routeNamesToHideMenu: ["Event"],
    isMainMenuHidden: true,
    menus: [
      [
        { title: "לוח בקרה", icon: "mdi-view-dashboard", path: "/" },
        {
          title: "משימות",
          icon: "mdi-calendar-check",
          path: "/tasks"
        }
      ],
      [
        {
          title: "הזמנות",
          icon: "mdi-file-document-outline",
          path: "/orders"
        },
        {
          title: "לקוחות",
          icon: "mdi-account",
          path: "/customers"
        },
        {
          title: "מכשירים",
          icon: "mdi-cellphone-basic",
          path: "/devices"
        },
        {
          title: "משלוחים",
          icon: "mdi-truck",
          path: "/deliveries"
        }
      ],
      [
        {
          title: "דו״חות",
          icon: "mdi-chart-bar",
          path: "/reports"
        }
      ],
      [
        {
          title: "הגדרות מערכת",
          icon: "mdi-settings",
          path: "/system-setup"
          // roles: ["ADMIN"]
        },
        {
          title: "דיווח על תקלה",
          icon: "mdi-bug",
          click: "openBugReportDialog"
        }
      ],
      [
        {
          title: "יציאה",
          icon: "mdi-logout",
          click: "logout"
        }
      ]
    ]
  }),

  computed: {
    isMainMenuActive: {
      get() {
        return this.$store.getters["isMainMenuActive"];
      },
      set(isActive) {
        this.$store.dispatch("TOGGLE_MAIN_MENU", { isActive });
      }
    },
    miniVariant: {
      get() {
        return this.$store.getters["mainMenuMiniVariant"];
      },
      set(isActive) {
        this.$store.dispatch("SET_MAIN_MENU_MINI_VARIANT", { isActive });
      }
    },
    nightMode: {
      get() {
        return this.$store.getters["nightMode"];
      },
      set(payload) {
        this.$store.dispatch("TOGGLE_NIGHT_MODE", { payload });
      }
    },
    shouldShowMainMenuAutomatically() {
      return this.$store.getters["shouldShowMainMenuAutomatically"];
    },
    user() {
      return this.$store.getters["user/user"];
    },
    userAvatar() {
      if (this.user.image) {
        return this.user.image;
      } else {
        return `https://ui-avatars.com/api/?name=${this.userAvatarName}&background=${this.userAvatarColor}&size=80&color=ffffff&rounded=1&length=1`;
      }
    },
    userAvatarName() {
      return this.user.name;
    },
    userAvatarColor() {
      let color = this.user.color;
      if (color) {
        color = camelCase(color);
      } else {
        color = "blue";
      }
      return colors[color].base.substr(1);
    },
    filteredMainMenu() {
      return this.mainMenu.filter(item => {
        return shouldShow(item.roles, this.user);
      });
    }
  },

  methods: {
    shouldShow,
    envokeMethodByName(name) {
      this[name]();
    },
    getBadgeDataByName(name) {
      return this[name]();
    },
    logout() {
      this.$root.$confirm("האם לצאת?").then(res => {
        if (!res) {
          return;
        }
        this.$store.dispatch("user/SIGN_OUT");
      });
    },
    openBugReportDialog() {
      this.$store.dispatch("bugReport/TOGGLE_BUG_REPORT_DIALOG", true);
    }
  },

  mounted() {},

  watch: {
    "$route.name": {
      handler: function(val) {
        if (this.routeNamesToHideMenu.indexOf(val) !== -1) {
          this.isMainMenuHidden = true;
        } else {
          this.isMainMenuHidden = false;
        }
      },
      immediate: true
    }
  }
};
</script>


<style scoped>
</style>
